import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DynamicModalAbstractComponent } from '../../../classes/dynamic-modal-abstract-component';
import { DynamicModalLoaderService } from '../../../services/dynamic-modal-loader.service';

@Component({
  selector: 'gen-basic-modal',
  templateUrl: './basic-modal.component.html',
  styleUrls: ['./basic-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasicModalComponent extends DynamicModalAbstractComponent implements OnInit {
  public content: string;
  public contentParams: string;

  constructor(modalLoaderService: DynamicModalLoaderService) {
    super(modalLoaderService);
  }

  onNext(payload): void {
    this.content = payload && payload['content'] || '';
    this.contentParams = payload && payload['params'] || '';
  }

  onError(error): void {
  }

  onComplete(): void {
  }

  ngOnInit() {
  }

}
